import React, { Component } from 'react'

import {RESERVED_SPACES_HINT} from '../../strings'

class ReservedSpacesDisplay extends Component {

    render(){
        const {reservedSpaces, onChange, onUpdate, updateSuccess} = this.props
        return(
            <div className="container-reserved-spaces-picker">
                <div className="line-header-text">Espacios reservados</div>
                <div className="subtitle-warning">
                    {RESERVED_SPACES_HINT}
                </div>
                <div className="input-error input-container-small">
                    <input type='number' value={reservedSpaces} onChange={onChange} className="text-input"/>
                </div>
                <div className="main-block">
                  <input
                      class="button-add-reserve"
                      type="button"
                      value="Actualizar"
                      onClick={onUpdate}/>
                </div>
                {
                  updateSuccess ?
                  <div className="text-success">Actualizado correctamente</div> : <div></div>
                }
            </div>
        )
    }
}

export default ReservedSpacesDisplay
